import getTokens from '../providers/getTokens';
import cryptojs from 'crypto-js';

/**
 * Encrypt the password payload into a stringify object in order to be sent as
 * request into the bff.
 *
 * @param  {Object } passwords
 * @param {string} passwords.newPassword  - password to be changed
 * @param {string} passwords.newConfirmationPassword - confirmation string of the password
 *
 * @return {string}  and string encrypted password
 */
const encryptPassword = (passwords) => {
  const { newPassword, newConfirmationPassword } = passwords;
  const wcToken = getTokens().wcToken();
  const wcTrustedToken = getTokens().wcTrustedToken();
  const encryptedTokens = btoa(`${wcTrustedToken}:${wcToken}`);

  return cryptojs.AES.encrypt(
    JSON.stringify({
      newPassword: newPassword,
      newConfirmationPassword: newConfirmationPassword,
    }),
    encryptedTokens,
  ).toString();
};
export default encryptPassword;
